module.exports = __webpack_public_path__ + "static/media/icon_lock.b87827ee.svg";